<mat-form-field class="generic-combobox" appearance="outline">
  <mat-label>
    {{ txtLabel }}
  </mat-label>
  <mat-select [(value)]="selected" (selectionChange)="emitSelected($event)">
    <mat-option *ngFor="let option of options" [value]="option">
      {{ option }}
    </mat-option>
  </mat-select>
</mat-form-field>
